<template>
  <div class="flex flex-col items-center justify-center min-h-screen px-4 py-12 bg-white dark:bg-zinc-900" data-testid="not-found-page">
    <div class="flex flex-col items-center w-full max-w-xl text-center">
      <!-- 404 Illustration -->
      <div class="w-full max-w-sm mb-12 opacity-80 dark:opacity-60">
        <img src="/404-art.svg" width="304" height="310" alt="Error page illustration" class="w-full h-auto" />
      </div>

      <!-- Error Message -->
      <div class="space-y-6 mb-12">
        <h1 class="text-5xl font-bold text-zinc-900 dark:text-zinc-50 tracking-tight leading-tight" data-testid="not-found-title">
          Oops. There's nothing here.
        </h1>

        <p class="text-lg leading-8 text-zinc-600 dark:text-zinc-400 px-4">
          Double check the URL or contact us at
          <a
            href="https://support.zight.com/"
            target="_blank"
            class="font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 underline underline-offset-4 decoration-2 transition-colors"
          >
            Support Page </a
          >.
        </p>

        <div class="pt-4 space-y-4">
          <p class="text-base text-zinc-500 dark:text-zinc-500 px-4">If this is your link, the upload may have failed.</p>
          <div class="flex flex-col gap-3 items-center">
            <a
              href="https://support.zight.com/hc/en-us/articles/5842175631127"
              target="_blank"
              class="text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 underline underline-offset-4 decoration-2 transition-colors"
            >
              Learn how to recover content
            </a>
            <a
              href="https://status.zight.com/"
              target="_blank"
              class="text-sm font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 underline underline-offset-4 decoration-2 transition-colors"
            >
              Check Zight Status Page
            </a>
          </div>
        </div>
      </div>

      <!-- Action Button -->
      <Button type="solid" variant="blue" icon="general.stars" data-testid="not-found-cta-button" @click.stop.prevent="handleSignUp">
        Get Zight for Free
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/storybook';

const handleSignUp = () => {
  window.location.href = 'https://share.zight.com/signup?utm_source=product&utm_medium=404_page&utm_campaign=404_page_signup';
};
</script>
